import React, { useContext } from 'react';
import { Logo, SVGIcons } from '~/assets';
import { Image, Link, Modal } from '~/components/Atoms';
import { SectionTextMedia } from '~/components/Molecules';
import HamburguerMenu from '~/components/Molecules/HamburguerMenu';
import { ModalContext, ThemeContext } from '~/contexts';
import {
  HeaderOptionsWrapper,
  IconButton,
  ImageWrapper,
  LinkWrapper,
  MenuHamburguerWrapper,
  SectionWrapper,
  Wrapper,
} from './styles';

const Header: React.FC = () => {
  const { switchThemeChoice, themeChoice } = useContext(ThemeContext);
  const { setModalVisibility } = useContext(ModalContext);

  const iconChoiceTheme: SVGIconKeys = themeChoice === 'light' ? 'moon' : 'sun';

  const handlePressBurger = () => {
    setModalVisibility(true);
  };

  const handlePressSun = () => {
    switchThemeChoice();
  };

  return (
    <>
      <Wrapper>
        <MenuHamburguerWrapper>
          <IconButton onClick={handlePressBurger}>{SVGIcons.menu()}</IconButton>
        </MenuHamburguerWrapper>
        <ImageWrapper>
          <Image src={Logo} alt="Logo" />
        </ImageWrapper>
        <HeaderOptionsWrapper>
          <LinkWrapper>
            <Link href="/" variant="headline4">
              Contato
            </Link>
          </LinkWrapper>
          <LinkWrapper>
            <Link href="/" variant="headline4">
              Modelos
            </Link>
          </LinkWrapper>
          <LinkWrapper>
            <Link href="/" variant="headline4">
              Quem Somos
            </Link>
          </LinkWrapper>
        </HeaderOptionsWrapper>
        <IconButton onClick={handlePressSun}>
          {SVGIcons[iconChoiceTheme]()}
        </IconButton>
      </Wrapper>
      <SectionWrapper>
        <SectionTextMedia fitContentHeight />
      </SectionWrapper>
      <Modal>
        <HamburguerMenu />
      </Modal>
    </>
  );
};

export default Header;
